import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../services/api'
import Swal from 'sweetalert2'
import { MainContext } from '../../context/MainContext'

const STATUS_OPTIONS = [
  { value: 'soon', label: 'Em breve' },
  { value: 'in_progress', label: 'Em andamento' },
  { value: 'finished', label: 'Finalizado' },
]

export default function EditEvent() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { setPageTitle, setLoading } = useContext(MainContext)

  const [eventTypes, setEventTypes] = useState<{ value: number; label: string }[]>([])

  const [form, setForm] = useState({
    title: '',
    description: '',
    status: 'soon',
    show_result: false,
    active: true,
    event_types_id: 0,
    discard_count: '' as any,
  })

  useEffect(() => {
    setLoading(true)
    Promise.all([api.get(`/api/events/${id}`), api.get('/api/eventTypes')])
      .then(([resEvent, resTypes]) => {
        const e = resEvent.data
        setForm({
          title: e.title ?? '',
          description: e.description ?? '',
          status: e.status ?? 'soon',
          show_result: !!e.show_result,
          active: !!e.active,
          event_types_id: e.event_types_id ?? 0,
          discard_count: e.discard_count ?? '',
        })
        setEventTypes(resTypes.data.map((t: any) => ({ value: t.id, label: t.description })))
      })
      .catch(() =>
        Swal.fire({ title: 'Erro!', text: 'Prova não encontrada', icon: 'error' }).then(() => navigate(-1))
      )
      .finally(() => setLoading(false))
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      setLoading(true)
      await api.put(`/api/events/${id}`, form)
      Swal.fire({ title: 'Sucesso!', text: 'Prova atualizada com sucesso!', icon: 'success', timer: 3000 }).then(() =>
        navigate(-1)
      )
    } catch (err: any) {
      Swal.fire({ title: 'Erro!', text: err?.response?.data?.message || err, icon: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Editar Prova</h5>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3">

              <div className="col-md-12">
                <label className="form-label">Título <i className="text-danger">*</i></label>
                <input name="title" className="form-control" value={form.title} onChange={handleChange} required />
              </div>

              <div className="col-md-12">
                <label className="form-label">Descrição</label>
                <textarea name="description" className="form-control" rows={3} value={form.description} onChange={handleChange} />
              </div>

              <div className="col-md-6">
                <label className="form-label">Tipo de evento <i className="text-danger">*</i></label>
                <select name="event_types_id" className="form-select" value={form.event_types_id} onChange={handleChange} required>
                  <option value={0} disabled>Selecione</option>
                  {eventTypes.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label className="form-label">Descartes</label>
                <input name="discard_count" type="number" min={0} className="form-control" value={form.discard_count} onChange={handleChange} />
              </div>

              <div className="col-md-3">
                <label className="form-label">Status <i className="text-danger">*</i></label>
                <select name="status" className="form-select" value={form.status} onChange={handleChange}>
                  {STATUS_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-4 d-flex align-items-end gap-4 pb-1">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="show_result" id="show_result"
                    checked={form.show_result} onChange={handleChange} />
                  <label className="form-check-label" htmlFor="show_result">Exibir resultado</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="active" id="active"
                    checked={form.active} onChange={handleChange} />
                  <label className="form-check-label" htmlFor="active">Ativo</label>
                </div>
              </div>

              <div className="col-12 d-flex gap-2">
                <button type="submit" className="btn btn-success">
                  <i className="bi bi-floppy2">&nbsp;</i>Salvar
                </button>
                <button type="button" className="btn btn-danger" onClick={() => navigate(-1)}>
                  <i className="bi bi-x-circle-fill">&nbsp;</i>Cancelar
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
